import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const RequestPassword = Loadable({
  loader: () => import("./RequestPassword"),
  loading: Loading
})
